export default __webpack_public_path__ + "static/media/logo-black.221ec82b.png";